/* unplugin-vue-components disabled */import script from "./Post.vue?vue&type=script&setup=true&lang=tsx"
export * from "./Post.vue?vue&type=script&setup=true&lang=tsx"

const __exports__ = script;

export default __exports__